import React from "react";
import { Badge, Space, Typography } from "antd";
import { LOW_STOCK_THRESHOLD } from "../constants";
import { getStockStatus } from "../utils";

const { Text } = Typography;

export default function StockStatus({ stock, maxStock }) {
  const status = getStockStatus(stock, LOW_STOCK_THRESHOLD);
  return (
    <Space direction="vertical" size={0}>
      <Badge status={status.color} text={`${stock} de ${maxStock}`} />
      <Text type="secondary" style={{ fontSize: 11 }}>
        Unidades
      </Text>
    </Space>
  );
}
